/**
 * Parse the string-based raw value of the cookie into a JS object
 */
var parseLocationCookieValue = function (cookieValue) {
    // short-circuit if the value is already an object
    if (typeof cookieValue === 'object') {
        return cookieValue;
    }
    // if undefined, avoid json.parse errors
    if (typeof cookieValue === 'undefined') {
        return {};
    }
    try {
        var cookieLocation = JSON.parse(cookieValue);
        return cookieLocation;
    }
    catch (_a) {
        // just in case
        return {};
    }
};
/**
 * Encode / serialize the object form of the cookie data into a string, ready to be added to document cookies
 */
var stringifyLocationCookieValue = function (cookieValue) {
    // short circuit if already a string
    if (typeof cookieValue === 'string') {
        return cookieValue;
    }
    if (typeof cookieValue === 'undefined') {
        return '';
    }
    try {
        return JSON.stringify(cookieValue);
    }
    catch (_a) {
        return '';
    }
};

export { parseLocationCookieValue, stringifyLocationCookieValue };
//# sourceMappingURL=parse.esm.js.map
